import { createContext, useContext } from 'react'

export type URLParamsFlags = {
    B2B: boolean
    loadTestData: boolean
    voucherIdentifier: string | undefined
    vzf: string | undefined
    type: string | undefined
    preselectedProduct: string | undefined
    vp: string | undefined
}

export const URLParams = (): URLParamsFlags => {
    const search = window.location.search
    const searchParams = new URLSearchParams(search)
    if (search.trim().length > 0) {
        let vp = undefined
        let v = undefined
        if (searchParams.get('vp')) {
            //remove slash at the end of the string
            vp = searchParams.get('vp')?.replace(/\/$/, '')
        }
        if (searchParams.get('v')) {
            v = searchParams.get('v')?.replace(/\/$/, '')
        }
        return {
            B2B: searchParams.has('b2b'),
            loadTestData: searchParams.has('t'),
            voucherIdentifier: v, // Returns the parameter if it exists, null if not
            vzf: searchParams.get('vzf') ?? undefined, // Returns the parameter if it exists, null if not
            type: searchParams.get('c') ?? undefined, // Returns the parameter if it exists, null if not
            preselectedProduct: searchParams.get('p') ?? undefined, // Returns the parameter if it exists, null if not
            vp: vp,
        }
    }
    return {
        B2B: false,
        loadTestData: false,
        vzf: undefined,
        type: undefined,
        voucherIdentifier: undefined,
        preselectedProduct: undefined,
        vp: undefined,
    }
}

export const URLParamsContext = createContext<URLParamsFlags>(URLParams())

const useURLParams = (): URLParamsFlags => {
    return useContext(URLParamsContext)
}

export default useURLParams
